import React, { useState, useEffect } from 'react';
import {
  Typography,
  Button,
} from '@mui/material';
import Card from "@mui/material/Card";
import MKBox from "components/MKBox";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKAvatar from "components/MKAvatar";
import MKButton from "components/MKButton";
import routes from "trainerRoutes";
import { useParams } from "react-router-dom";
import Breadcrumbs from "examples/Breadcrumbs";
import SimpleFooter from "examples/Footers/SimpleFooter";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MKAlert from "components/MKAlert";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const LoadingOverlay = ({ loading, children }) => {
  return (
    <>
      {loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            filter: 'blur(5px)',
            pointerEvents: 'none',
          }}
          open={loading}
        >
          <MKBox
            sx={{
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: "1",
              width: "100%",
              minHeight: "100vh",
              // display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {children}
          </MKBox>
        </Backdrop>
      )}
      {loading && (
        <MKBox
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          <CircularProgress />
        </MKBox>
      )}
      {!loading && children}
    </>
  );
};

function Author() {
  const { trainingCompanyID } = useParams();
  const [trainingCompanyList, setTrainingCompanyList] = useState([]);
  const [bbdata, setbbData] = useState([]);
  const [trainingList, setTrainingList] = useState([]);
  const [submitCompleted, setSubmitCompleted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [socialMedia, setSocialMedia] = useState('');
  const [additionalContactDetails, setAdditionalContactDetails] = useState('');
  const [headQuartersDetails, setHeadQuartersDetails] = useState('');
  const [responseFromDB, setResponseFromDB] = useState("");
  const [submitRemainderCompleted, setSubmitRemainderCompleted] = useState(false);
  const [recruitSubmitCompleted, setRecruitSubmitCompleted] = useState(false);
  const [maxRemainderCount, setMaxRemainderCount] = useState(false);
  const [avatarBackgroundColor, setAvatarBackgroundColor] = useState('#ccc');
  const [profilePicture, setProfilePicture] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/recruit-company-more-details/${trainingCompanyID}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setbbData(data);
          setTrainingCompanyList(data[0]);
          setSocialMedia(data[0].socialMedia);
          setHeadQuartersDetails(data[0].tcpHQAddress);
          setProfilePicture(data[0].companyLogo);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [trainingCompanyID]);

  console.log("trainingCompanyList", trainingCompanyList);
  console.log("data", bbdata);
  console.log("socialMedia", socialMedia);
  console.log("socialMedia", additionalContactDetails);

  const DialogProfileClose = () => {
    setShowModal(false);
    window.location.href = "/portal";
  };

  const onBackClick = () => {
    window.location.href = "/app/trainerdashboard";
  };

  function getStatus(trainingCompanyList) {
    if (trainingCompanyList.trainingCompanyRecruitStatus === "Yes" && trainingCompanyList.trainerAcceptStatus === null && trainingCompanyList.trainingCompanyAgreeStatus === null) {
      return "Awaiting For Your response";
    } else if (trainingCompanyList.trainingCompanyRecruitStatus === "Yes" && trainingCompanyList.trainerAcceptStatus === "Accept" && trainingCompanyList.trainingCompanyAgreeStatus === null) {
      return "Awaiting for Company's response";
    } else if (trainingCompanyList.trainingCompanyRecruitStatus === "Yes" && trainingCompanyList.trainerAcceptStatus === "Decline" && trainingCompanyList.trainingCompanyAgreeStatus === null) {
      return "You have Declined the Company's request";
    } else if (trainingCompanyList.trainingCompanyRecruitStatus === "Yes" && trainingCompanyList.trainerAcceptStatus === "Accept" && trainingCompanyList.trainingCompanyAgreeStatus === "Accept") {
      return "Mutually agreed for the training";
    } else if (trainingCompanyList.trainingCompanyRecruitStatus === "Yes" && trainingCompanyList.trainerAcceptStatus === "Accept" && trainingCompanyList.trainingCompanyAgreeStatus === "Decline") {
      return "Trainer has been rejected";
    } else {
      return "Status not available";
    }
  }

  const onRecruitAgreeClick = (company) => {
    setLoading(true);
    console.log("2222222222", company);
    const data = {
      trainerAcceptStatus: "Accept",
      trainingCompanyID: company.user_id,
      trainerID: company.trainerID,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/redir-trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setRecruitSubmitCompleted(true);
        } else {
          setRecruitSubmitCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
        setLoading(false);
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };


  const DialogProfileRecruitAcceptClose = () => {
    setRecruitSubmitCompleted(false);
    window.location.href = "/app/trainerdashboard";
  };

  const [trainerDetails, setTrainerDetails] = useState([]);
  useEffect(() => {
    let id = localStorage.getItem("userId");
    fetch(`${process.env.REACT_APP_API_URL}/api/trainer-profile-list/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setTrainerDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("trainerDetails", trainerDetails);

  const onRecruitRemainderClick = (training) => {
    // console.log("recruitRemainder", training.trainerRecruitID);
    setLoading(true);
    setMaxRemainderCount(false);
    console.log("recruitRemainder", training);
    const data = {
      id: trainingCompanyID,
      premiumStatus: trainerDetails.premiumStatus,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/redir-company-status-intodb-reminder/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          setSubmitRemainderCompleted(false);
          throw new Error("Profile is not created. Something went wrong");
        }
      })
      .then((data) => {
        console.log("Response from backend:", data.message);
        if (data.message === "Remainder reached maximum for the day") {
          setResponseFromDB(data.message);
          setMaxRemainderCount(true);
        } else if (data.message === "Trainer's Accept/ Decline status successfully updated in DB" || data.message === "count update and date updated, mail sent") {
          setResponseFromDB(data.message);
          setSubmitRemainderCompleted(true);
        } else {
          setResponseFromDB(data.message);
          setSubmitRemainderCompleted(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error:", error.message);
      });
  };

  console.log("responseFromDB", responseFromDB);

  const DialogRemainderProfileClose = () => {
    setSubmitRemainderCompleted(false);
  };

  return (
    <>
      <LoadingOverlay loading={loading}>
        <IdleTimeOutHandler />
        <DefaultNavbar
          routes={routes}
        />
        <MKBox bgColor="white">
          <Card
            sx={{
              p: 2,
              mx: { xs: 2, lg: 3 },
              // mt: -8,
              mb: 4,
              // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
              backdropFilter: "saturate(200%) blur(30px)",
              boxShadow: ({ boxShadows: { xxl } }) => xxl,
            }}
          >
            <MKBox component="section" py={{ xs: 6, sm: 12 }}>
              <Container>
                <div>
                  {maxRemainderCount ? (
                    <MKAlert color="error" dismissible >
                      You've reached the daily remainder limit !
                    </MKAlert>
                  ) : (
                    ""
                  )}
                </div>
                <Grid container item xs={12} justifyContent="center" mx="auto">
                  <MKBox textAlign="center">
                    <MKAvatar
                      src={`${process.env.REACT_APP_API_URL}${profilePicture}/`}
                      alt="Profile picture" size="xxl" shadow="xl"
                      style={{ backgroundColor: avatarBackgroundColor }} />
                  </MKBox>
                  <Dialog
                    open={submitCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Notification !
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your Response has been succesfully submitted !
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                      <MKButton onClick={() => { setSubmitCompleted(false); DialogProfileClose(); }} variant="contained" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={recruitSubmitCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Notification !
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your response submitted to the training partner.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                      <MKButton onClick={() => { setRecruitSubmitCompleted(false); DialogProfileRecruitAcceptClose(); }} variant="contained" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitRemainderCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Good News !
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                      Reminder sent successfully! Your gentle nudge has been delivered.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                      <MKButton onClick={() => { setSubmitRemainderCompleted(false); DialogRemainderProfileClose(); }} variant="contained" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Grid container justifyContent="center" py={6} style={{ marginTop: "-40px" }}>
                    <Grid item xs={12} md={12} mx={{ xs: "auto", sm: 6, md: 1 }}>
                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Typography variant="h3">{trainingCompanyList.companyName}</Typography>
                      </MKBox>
                      <MKBox display="flex" justifyContent="center" alignItems="center" mb={1}>
                        <Typography variant="h5">Status :&nbsp; {getStatus(trainingCompanyList)}</Typography>
                      </MKBox>
                      <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                          <Breadcrumbs
                            routes={[{ label: <span style={{ fontWeight: 'bold' }}>Training Partner's Details</span> }]}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={1} mb={1}>
                        <Grid item>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Trainings Offered :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "47px" }}>
                            {trainingCompanyList.trainingOffered}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={1} mb={1}>
                        <Grid item>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Previous Clients :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "55px" }}>
                            {trainingCompanyList.clients}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container spacing={1} mb={1}>
                        <Grid item>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Supported Time Zone :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "18px" }}>
                            {trainingCompanyList.supportedClientTimezone}&nbsp;
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={2.5}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            About Training Partner :&nbsp;
                          </Typography>
                        </Grid>
                        <Grid item xs={8.5}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "0px" }}>
                            {trainingCompanyList.profile} <br />
                          </Typography>
                        </Grid>
                      </Grid>

                      {(
                        trainerDetails.premiumStatus === "yes" ||
                        (getStatus(trainingCompanyList) === "Mutually agreed for the training")) && (
                          <>
                            <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                              <Grid item xs={12}>
                                <Breadcrumbs
                                  routes={[{ label: <span style={{ fontWeight: 'bold' }}>Training Partner's Contact Details</span> }]}
                                />
                              </Grid>
                            </Grid>
                            <Grid container spacing={4} mb={1}>
                              <Grid item xs={6}>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                  Email-ID :&nbsp;
                                </Typography>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                                  {trainingCompanyList.email}
                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text">
                                  Mobile Number :&nbsp;
                                </Typography>
                                <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                                  {trainingCompanyList.mobileNumber}&nbsp;
                                </Typography>
                              </Grid>
                            </Grid>
                          </>
                        )}

                      <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                        <Grid item xs={12}>
                          <Breadcrumbs
                            routes={[{ label: <span style={{ fontWeight: 'bold' }}>Training Partner's Head Quarters Details</span> }]}
                          />
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={5}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Address Line 1 :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                            {headQuartersDetails && headQuartersDetails.addressLine1}
                          </Typography>
                        </Grid>
                        <Grid item xs={5}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            Address Line 2 :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                            {headQuartersDetails && headQuartersDetails.addressLine2}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={4} mb={1}>
                        <Grid item xs={3}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                            Country :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                            {headQuartersDetails && headQuartersDetails.country}
                          </Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            State :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "55px" }}>
                            {headQuartersDetails && headQuartersDetails.state}
                          </Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" >
                            City :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "65px" }}>
                            {headQuartersDetails && headQuartersDetails.city}
                          </Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text">
                            Pincode :&nbsp;
                          </Typography>
                          <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "37px" }}>
                            {headQuartersDetails && headQuartersDetails.pincode}
                          </Typography>
                        </Grid>
                      </Grid>
                      {socialMedia && (
                        <>
                          <Grid container spacing={1} mb={1} style={{ marginTop: "10px" }}>
                            <Grid item xs={12}>
                              <Breadcrumbs
                                routes={[{ label: <span style={{ fontWeight: 'bold' }}>Training Partner's Social Media Details</span> }]}
                              />
                            </Grid>
                          </Grid>

                          <Grid container spacing={1} mb={1}>
                            <Grid item>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                LinkedIn URL :&nbsp;
                              </Typography>
                              {socialMedia && (
                                <a
                                  href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ marginLeft: "5px", textDecoration: "underline" }}
                                >
                                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "49px", textDecoration: "underline", color: "blue" }}>
                                    {JSON.parse(socialMedia.replace(/'/g, '"')).linkedInUrl}
                                  </Typography>
                                </a>
                              )}
                            </Grid>
                          </Grid>

                          <Grid container spacing={1} mb={1}>
                            <Grid item>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Facebook URL :&nbsp;
                              </Typography>
                              {socialMedia && (
                                <a
                                  href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ marginLeft: "5px", textDecoration: "underline" }}
                                >
                                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "40px", textDecoration: "underline", color: "blue" }}>
                                    {JSON.parse(socialMedia.replace(/'/g, '"')).facebookUrl}
                                  </Typography>
                                </a>
                              )}
                            </Grid>
                          </Grid>

                          <Grid container spacing={1} mb={1}>
                            <Grid item>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Twitter URL :&nbsp;
                              </Typography>
                              {socialMedia && (
                                <a
                                  href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ marginLeft: "5px", textDecoration: "underline" }}
                                >
                                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "61px", textDecoration: "underline", color: "blue" }}>
                                    {JSON.parse(socialMedia.replace(/'/g, '"')).twitterUrl}
                                  </Typography>
                                </a>
                              )}
                            </Grid>
                          </Grid>

                          <Grid container spacing={1} mb={1}>
                            <Grid item>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Instagram URL :&nbsp;
                              </Typography>
                              {socialMedia && (
                                <a
                                  href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ marginLeft: "5px", textDecoration: "underline" }}
                                >
                                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "38px", textDecoration: "underline", color: "blue" }}>
                                    {JSON.parse(socialMedia.replace(/'/g, '"')).instagramUrl}
                                  </Typography>
                                </a>
                              )}
                            </Grid>
                          </Grid>

                          <Grid container spacing={1} mb={1}>
                            <Grid item>
                              <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "15px" }}>
                                Youtube URL :&nbsp;
                              </Typography>
                              {socialMedia && (
                                <a
                                  href={socialMedia && JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl.startsWith("http") ? JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl : `http://${JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ marginLeft: "5px", textDecoration: "underline" }}
                                >
                                  <Typography component="span" variant="body2" fontWeight="regular" color="text" style={{ marginLeft: "52px", textDecoration: "underline", color: "blue" }}>
                                    {JSON.parse(socialMedia.replace(/'/g, '"')).youtubeUrl}
                                  </Typography>
                                </a>
                              )}
                            </Grid>
                          </Grid>
                        </>
                      )}

                    </Grid>
                  </Grid>
                  <Grid container justifyContent="center" spacing={2} mt={2} style={{ marginTop: "-40px", marginBottom: "-80px" }}>
                    <Grid item>
                      <MKButton
                        variant="gradient"
                        color="info"
                        size="small"
                        onClick={() => onBackClick()}
                        style={{ padding: '5px 10px' }}
                      >
                        Back
                      </MKButton>
                    </Grid>
                    {getStatus(trainingCompanyList) === "Awaiting for Company's response" && (
                      <>
                        <Grid item>
                          <MKButton
                            variant="gradient"
                            color="info"
                            size="small"
                            onClick={() => onRecruitRemainderClick(trainingCompanyList)}
                            style={{ padding: '5px 10px' }}
                          >
                            Send Remainder
                          </MKButton>
                        </Grid>
                      </>
                    )}

                    {getStatus(trainingCompanyList) === "Awaiting For Your response" && (
                      <>
                        <Grid item>
                          <MKButton
                            variant="gradient"
                            color="info"
                            size="small"
                            onClick={() => onRecruitAgreeClick(trainingCompanyList)}
                            style={{ padding: '5px 10px' }}
                          >
                            Accept
                          </MKButton>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Grid>
              </Container>
            </MKBox>
          </Card>
          <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
              <SimpleFooter />
            </MKBox>
          </div>
        </MKBox>
      </LoadingOverlay>
    </>
  );
}

export default Author;
